import useSWR  from "swr"

export default function useRegions() {
    const { data: regions, mutate } = useSWR("api/v1/utils/vk-ads/regions")
    return {
        regions,
        mutate
    }
}